const s = {
  name: "Watch2",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7,21h10v-2H7V21z"/>
		<path class="st0" d="M17,16H7v-2h10V16z"/>
		<path class="st0" d="M7,26h10v-2H7V26z"/>
		<path class="st0" d="M6.2,0h11.6l1.3,6c2.7,0.1,4.9,2.3,4.9,5v18c0,2.7-2.2,4.9-4.9,5l-1.3,6H6.2l-1.3-6C2.2,33.9,0,31.7,0,29V11
			c0-2.7,2.2-4.9,4.9-5L6.2,0z M16.2,2H7.8L6.9,6h10.2L16.2,2z M6.9,34l0.9,4h8.4l0.9-4H6.9z M5,8c-1.7,0-3,1.3-3,3v18
			c0,1.7,1.3,3,3,3h14c1.7,0,3-1.3,3-3V11c0-1.7-1.3-3-3-3H5z"/>
		<path class="st0" d="M28,16v8h-2v-8H28z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Watch2
};
